<template>
  <BaseButton class="button-toggle" @click="toggle">
    <span>
      {{ $t(`order.${model}`) }}
    </span>
    <BaseIcon icon="filter_list" />
  </BaseButton>
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue: "asc" | "desc";
}>();

const emit = defineEmits(["update:modelValue"]);
const model = useVModel(props, "modelValue", emit);

const toggle = () => {
  if (model.value === "asc") {
    model.value = "desc";
  } else {
    model.value = "asc";
  }
};
</script>

<style lang="scss" scoped>
.button-toggle {
  min-width: 14rem;
  display: flex;
  justify-content: space-between;
}
</style>
